export default __webpack_public_path__ + "static/media/stephanie_tommy-461.ec221638.jpg";